import {RequestState} from "modules/enums";

export function parseRequestState(state: RequestState) {
	const isIdle = state === RequestState.IDLE;
	const isLoading = state === RequestState.Requested;
	const isComplete = state === RequestState.Received;

	return {isIdle, isLoading, isComplete, requestState: state};
}
